/* eslint-disable prettier/prettier */
import React from 'react'
import { Translation } from 'react-i18next'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))

// User Management
const AllUser = React.lazy(() => import('./views/usermanagement/users/AllUser'))
const CreateUser = React.lazy(() => import('./views/usermanagement/users/CreateUser'))
const EditUser = React.lazy(() => import('./views/usermanagement/users/EditUser'))
const ViewUser = React.lazy(() => import('./views/usermanagement/users/ViewUser'))
const ViewProfile = React.lazy(() => import('./views/usermanagement/viewprofile/ViewProfile'))
const ChangePassword = React.lazy(() => import('./views/usermanagement/changepassword/ChangePassword'))
// Roles
const ViewRole = React.lazy(() => import('./views/usermanagement/roles/ViewRole'))
const AddRole = React.lazy(() => import('./views/usermanagement/roles/AddRole'))
const EditRole = React.lazy(() => import('./views/usermanagement/roles/EditRole'))
// Menu
const CreateMenu = React.lazy(() => import('./views/usermanagement/menu/CreateMenu'))
const MenusList = React.lazy(() => import('./views/usermanagement/menu/MenusList'))
const EditMenu = React.lazy(() => import('./views/usermanagement/menu/EditMenu'))
const ViewMenus = React.lazy(() => import('./views/usermanagement/menu/ViewMenus'))

// Location
const CountryList = React.lazy(() => import('./views/location/country/CountryList'))
const AddCountry = React.lazy(() => import('./views/location/country/AddCountry'))
const EditCountry = React.lazy(() => import('./views/location/country/EditCountry'))
const StateList = React.lazy(() => import('./views/location/state/StateList'))
const AddState = React.lazy(() => import('./views/location/state/AddState'))
const EditState = React.lazy(() => import('./views/location/state/EditState'))
const CitiesList = React.lazy(() => import('./views/location/cities/CitiesList'))
const AddCity = React.lazy(() => import('./views/location/cities/AddCity'))
const EditCity = React.lazy(() => import('./views/location/cities/EditCity'))

// CMS 
const WebPage = React.lazy(() => import('./views/cms/webpage/WebPageList'))
const PageBanner = React.lazy(() => import('./views/cms/pagebanner/PageBanners'))
const AddPageBanner = React.lazy(() => import('./views/cms/pagebanner/AddPageBanner'))
const EditPageBanner = React.lazy(() => import('./views/cms/pagebanner/EditPageBanner'))
const HomeBanner = React.lazy(() => import('./views/cms/homebanner/HomeBanner'))
const AddBanner = React.lazy(() => import('./views/cms/homebanner/AddBanner'))
const EditBanner = React.lazy(() => import('./views/cms/homebanner/EditBanner'))
const GalleryList = React.lazy(() => import('./views/cms/gallery/GalleryList'))
const AddGallery = React.lazy(() => import('./views/cms/gallery/AddGallery'))
const EditGallery = React.lazy(() => import('./views/cms/gallery/EditGallery'))
const LeadersList = React.lazy(() => import('./views/cms/leaders/LeadersList'))
const AddLeaders = React.lazy(() => import('./views/cms/leaders/AddLeaders'))
const EditLeaders = React.lazy(() => import('./views/cms/leaders/EditLeaders'))
const OfficesList = React.lazy(() => import('./views/cms/offices/OfficesList'))
const AddOffice = React.lazy(() => import('./views/cms/offices/AddOffice'))
const EditOffice = React.lazy(() => import('./views/cms/offices/EditOffice'))
const DonationList = React.lazy(() => import('./views/cms/donations/DonationList'))
const AddDonation = React.lazy(() => import('./views/cms/donations/AddDonation'))
const EditDonation = React.lazy(() => import('./views/cms/donations/EditDonation'))
const AwardsList = React.lazy(() => import('./views/cms/awards/AwardsList'))
const AddAward = React.lazy(() => import('./views/cms/awards/AddAward'))
const EditAward = React.lazy(() => import('./views/cms/awards/EditAward'))
const AllPages = React.lazy(() => import('./views/cms/allpages/AllPages'))
const KeyInitiativesList = React.lazy(() => import('./views/cms/keyinitiatives/KeyInitiativesList'))
const AddKeyInitiatves = React.lazy(() => import('./views/cms/keyinitiatives/AddKeyInitiatives'))
const EditKeyInitiatves = React.lazy(() => import('./views/cms/keyinitiatives/EditKeyInitiatives'))

// Insights
const NewsList = React.lazy(() => import('./views/insights/news/NewsList'))
const AddNews = React.lazy(() => import('./views/insights/news/AddNews'))
const EditNews = React.lazy(() => import('./views/insights/news/EditNews'))
const EventsList = React.lazy(() => import('./views/insights/events/EventsList'))
const AddEvent = React.lazy(() => import('./views/insights/events/AddEvent'))
const EditEvent = React.lazy(() => import('./views/insights/events/EditEvent'))

// Membership Management
const PendingMembers = React.lazy(() => import('./views/membership/PendingMembers'))
const ApprovedMembersList = React.lazy(() => import('./views/membership/ApproveMembersList'))
const RejectedMembers = React.lazy(() => import('./views/membership/RejectedMembers'))
const ViewMembers = React.lazy(() => import('./views/membership/ViewMembers'))

// Masters
const BodyTypeList = React.lazy(() => import('./views/masters/bodytype/BodyTypeList'))
const AddBodyType = React.lazy(() => import('./views/masters/bodytype/AddBodyType'))
const EditBodyType = React.lazy(() => import('./views/masters/bodytype/EditBodyType'))
const AnnualIncomeList = React.lazy(() => import('./views/masters/annualincome/AnnualIncomeList'))
const AddAnnualIncome = React.lazy(() => import('./views/masters/annualincome/AddAnnualIncome'))
const EditAnnualIncome = React.lazy(() => import('./views/masters/annualincome/EditAnnualIncome'))
const CategoryList = React.lazy(() => import('./views/masters/category/CategoryList'))
const AddCategory = React.lazy(() => import('./views/masters/category/AddCategory'))
const EditCategory = React.lazy(() => import('./views/masters/category/EditCategory'))
const DegreeList = React.lazy(() => import('./views/masters/degree/DegreeList'))
const AddDegree = React.lazy(() => import('./views/masters/degree/AddDegree'))
const EditDegree = React.lazy(() => import('./views/masters/degree/EditDegree'))
const DegreeGradeList = React.lazy(() => import('./views/masters/degreegrade/DegreeGradeList'))
const AddDegreeGrade = React.lazy(() => import('./views/masters/degreegrade/AddDegreeGrade'))
const EditDegreeGrade = React.lazy(() => import('./views/masters/degreegrade/EditDegreeGrade'))
const DesignationList = React.lazy(() => import('./views/masters/designations/DesignationList'))
const AddDesignation = React.lazy(() => import('./views/masters/designations/AddDesignation'))
const EditDesignation = React.lazy(() => import('./views/masters/designations/EditDesignation'))
const EmpNatureList = React.lazy(() => import('./views/masters/empnature/EmpNatureList'))
const AddEmpNature = React.lazy(() => import('./views/masters/empnature/AddEmpNature'))
const EditEmpNature = React.lazy(() => import('./views/masters/empnature/EditEmpNature'))
const GendersList = React.lazy(() => import('./views/masters/gender/GenderList'))
const AddGender = React.lazy(() => import('./views/masters/gender/AddGender'))
const EditGender = React.lazy(() => import('./views/masters/gender/EditGender'))
const MaritalStatusList = React.lazy(() => import('./views/masters/maritalstatus/MaritalStatusList'))
const AddMaritalStatus = React.lazy(() => import('./views/masters/maritalstatus/AddMaritalStatus'))
const EditMaritalStatus = React.lazy(() => import('./views/masters/maritalstatus/EditMaritalStatus'))
const NationalityList = React.lazy(() => import('./views/masters/nationality/NationalityList'))
const AddNationality = React.lazy(() => import('./views/masters/nationality/AddNationality'))
const EditNationality = React.lazy(() => import('./views/masters/nationality/EditNationality'))
const MotherTongueList = React.lazy(() => import('./views/masters/mothertongue/MotherTonguesList'))
const AddMotherTongue = React.lazy(() => import('./views/masters/mothertongue/AddMotherTongue'))
const EditMotherTongue = React.lazy(() => import('./views/masters/mothertongue/EditMotherTongue'))
const RelationshipList = React.lazy(() => import('./views/masters/relationship/RelationshipList'))
const AddRelationship = React.lazy(() => import('./views/masters/relationship/AddRelationship'))
const EditRelationship = React.lazy(() => import('./views/masters/relationship/EditRelationship'))
const OccupationsList = React.lazy(() => import('./views/masters/occupation/OccupationsList'))
const AddOccupation = React.lazy(() => import('./views/masters/occupation/AddOccupation'))
const EditOccupation = React.lazy(() => import('./views/masters/occupation/EditOccupation'))
const ReligionsList = React.lazy(() => import('./views/masters/religion/ReligionsList'))
const AddReligion = React.lazy(() => import('./views/masters/religion/AddReligion'))
const EditReligion = React.lazy(() => import('./views/masters/religion/EditReligion'))
const SkinColorsList = React.lazy(() => import('./views/masters/skincolors/SkinColorsList'))
const AddSkinColor = React.lazy(() => import('./views/masters/skincolors/AddSkinColor'))
const EditSkinColor = React.lazy(() => import('./views/masters/skincolors/EditSkinColor'))

// jobs
const PendingJobs = React.lazy(() => import('./views/jobs/PendingJobs'))
const ApprovedJobs = React.lazy(() => import('./views/jobs/ApprovedJobs'))
const RejectedJobs = React.lazy(() => import('./views/jobs/RejectedJobs'))
const ViewJobs = React.lazy(() => import('./views/jobs/ViewJobs'))

// Matrimonial
const PendingMemberMatrimonial = React.lazy(() => import('./views/matrimonial/PendingMemberMatrimonial'))
const ApproveMemberMatrimonial = React.lazy(() => import('./views/matrimonial/ApproveMemberMatrimonial'))
const RejectedProfiles = React.lazy(() => import('./views/matrimonial/RejectedProfiles'))
const ViewProfiles = React.lazy(() => import('./views/matrimonial/ViewProfie'))

const routes = [
  { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
  {
    path: '/dashboard',
    name: <Translation>{(t) => t('Dashboard')}</Translation>,
    element: Dashboard,
  },
  {
    path: './usermanagement',
    name: <Translation>{(t) => t('usermanagement')}</Translation>,
    exact: true,
  },
  {
    path: '/usermanagement/roles/viewrole',
    // name: 'Usermanagement/Roles',
    element: ViewRole
  },
  {
    path: '/usermanagement/roles/addrole',
    // name: 'Usermanagement/AddRole',
    element: AddRole
  },
  {
    path: '/usermanagement/roles/editrole/:roleid',
    // name: 'Usermanagement/roles/EditRole',
    element: EditRole
  },
  {
    path: '/usermanagement/users/alluser',
    // name: 'Usermanagement/UserList',
    element: AllUser,
  },
  {
    path: '/usermanagement/users/createuser',
    element: CreateUser,
  },
  {
    path: 'usermanagement/users/edituser/:userid',
    // name: 'Usermanagement/UserList/EditUser',
    element: EditUser,
  },
  {
    path: '/usermanagement/users/viewuser/:userid',
    // name: 'Usermanagement/Users/ViewUser',
    element: ViewUser
  },
  {
    path: 'usermanagement/viewprofile/viewprofile',
    // name: 'ViewProfile',
    element: ViewProfile,
  },
  {
    path: '/usermanagement/changepassword/changepassword',
    // name: 'ChangePassword',
    element: ChangePassword,
  },
  {
    path: '/usermanagement/menu/viewmenu',
    // name: 'MenusList',
    element: MenusList
  },
  {
    path: '/usermanagement/menu/createmenu',
    // name: 'Usermanagement/Menu/CreateMenu',
    element: CreateMenu
  },
  {
    path: '/usermanagement/menu/editmenu/:menuid',
    // name: 'Usermanagement/Menu/EditMenu',
    element: EditMenu
  },
  {
    path: '/usermanagement/menu/viewmenus/:menuId',
    // name: 'Usermanagement/Menu/ViewMenus',
    element: ViewMenus
  },
  {
    path: './location',
    name: <Translation>{(t) => t('location')}</Translation>,
    exact: true,
  },
  {
    path: '/location/country/countrylist',
    // name: "Location/CountryList",
    element: CountryList
  },
  {
    path: '/location/country/addcountry',
    // name: "Location/CountryList/AddCountry",
    element: AddCountry
  },
  {
    path: '/location/country/editcountry/:countryid',
    // name: "Location/CountryList/EditCountry",
    element: EditCountry
  },
  {
    path: '/location/state/statelist',
    // name: "Location/StateList",
    element: StateList
  },
  {
    path: '/location/state/addstate',
    // name: "Location/StateList/AddState",
    element: AddState
  },
  {
    path: '/location/state/editstate/:stateid',
    // name: "Location/StateList/EditState",
    element: EditState
  },
  {
    path: '/location/cities/citieslist',
    // name: "Location/CitiesList",
    element: CitiesList
  },
  {
    path: '/location/cities/addcity',
    // name: "Location/CitiesList/AddCity",
    element: AddCity
  },
  {
    path: '/location/cities/editcity/:Cityid',
    // name: "Location/CitiesList/EditCity",
    element: EditCity
  },

  // CMS

  {
    path: './cms',
    name: <Translation>{(t) => t('cms')}</Translation>,
    exact: true,
  },
  {
    path: '/cms/webpage/webpagelist',
    // name: "WebPage",
    element: WebPage
  },
  {
    path: '/cms/pagebanner/pagebanner',
    // name: "CMS/PageBanner",
    element: PageBanner
  },
  {
    path: '/cms/pagebanner/addpagebanner',
    // name: "CMS/PageBanner/AddPageBanner",
    element: AddPageBanner
  },
  {
    path: '/cms/pagebanner/editpagebanner/:pagebannerid',
    // name: "CMS/PageBanner/EditPageBanner",
    element: EditPageBanner
  },
  {
    path: '/cms/homebanner/homebanner',
    // name: "CMS/HomeBanner",
    element: HomeBanner
  },
  {
    path: '/cms/homebanner/addbanner',
    // name: 'CMS/HomeBanner/AddBanner',
    element: AddBanner
  },
  {
    path: '/cms/homebanner/editbanner/:bannerid',
    // name: "CMS/HomeBanner/EditBanner",
    element: EditBanner
  },
  {
    path: '/cms/gallery/gallerylist',
    // name: "CMS/GalleryList",
    element: GalleryList
  },
  {
    path: '/cms/gallery/addgallery',
    // name: 'CMS/GalleryList/AddGallery',
    element: AddGallery
  },
  {
    path: '/cms/gallery/editgallery/:Galleryid',
    // name: 'CMS/GalleryList/EditGallery',
    element: EditGallery
  },
  {
    path: '/cms/leaders/leaderslist',
    // name: "CMS/LeadersList",
    element: LeadersList
  },
  {
    path: '/cms/leaders/addleaders',
    // name: "CMS/LeadersList/AddLeaders",
    element: AddLeaders
  },
  {
    path: '/cms/leaders/editleaders/:Leaderid',
    // name: "CMS/LeadersList/EditLeaders",
    element: EditLeaders
  },
  {
    path: '/cms/offices/officeslist',
    // name: "CMS/OfficesList",
    element: OfficesList
  },
  {
    path: '/cms/offices/addoffice',
    // name: "CMS/OfficesList/AddOffice",
    element: AddOffice
  },
  {
    path: '/cms/offices/editoffice/:Officeid',
    // name: "CMS/OfficesList/EditOffice",
    element: EditOffice
  },
  {
    path: '/cms/donations/donationlist',
    // name: "CMS/DonationList",
    element: DonationList
  },
  {
    path: '/cms/donations/adddonation',
    // name: "CMS/DonationList/AddDonation",
    element: AddDonation
  },
  {
    path: '/cms/donations/editdonation/:donationid',
    // name: "CMS/DonationList/EditDonation",
    element: EditDonation
  },
  {
    path: '/cms/awards/awardslist',
    // name: "CMS/AwardsList",
    element: AwardsList
  },
  {
    path: '/cms/awards/addaward',
    // name: "CMS/AwardsList/AddAward",
    element: AddAward
  },
  {
    path: '/cms/awards/editaward/:awardid',
    // name: "CMS/AwardsList/EditAward",
    element: EditAward
  },
  {
    path: '/cms/allpages/allpages',
    // name: "CMS/AllPages",
    element: AllPages
  },
  {
    path: '/cms/keyinitiatves/keyinitiativeslist',
    // name: "CMS/KeyInitiativesList",
    element: KeyInitiativesList
  },
  {
    path: '/cms/keyinitiatves/addkeyinitiatves',
    // name: "CMS/KeyInitiativesList/AddKeyInitiatves",
    element: AddKeyInitiatves
  },
  {
    path: '/cms/keyinitiatves/editkeyinitiatves/:keyInitiativeId',
    // name: "CMS/KeyInitiativesList/EditKeyInitiatves",
    element: EditKeyInitiatves
  },

  // Insights

  {
    path: './insights',
    name: <Translation>{(t) => t('insights')}</Translation>,
    exact: true,
  },
  {
    path: '/insights/news/newslist',
    // name: "Insights/NewsList",
    element: NewsList
  },
  {
    path: '/insights/news/addnews',
    // name: "Insights/NewsList/AddNews",
    element: AddNews
  },
  {
    path: '/insights/news/editnews/:newsid',
    // name: "Insights/NewsList/EditNews",
    element: EditNews
  },
  {
    path: '/insights/events/eventslist',
    // name: "Insights/EventsList",
    element: EventsList
  },
  {
    path: '/insights/events/addevent',
    // name: "Insights/EventsList/AddEvent",
    element: AddEvent
  },
  {
    path: '/insights/events/editevent/:eventid',
    // name: "Insights/EventsList/EditEvent",
    element: EditEvent
  },


  {
    path: './membership',
    name: <Translation>{(t) => t('membership')}</Translation>,
    exact: true,
  },
  {
    path: '/membership/pendingmembers',
    // name: 'Membership/PendingMembers',
    element: PendingMembers
  },
  {
    path: '/membership/approvememberslist',
    // name: 'Membership/ApprovedMembersList',
    element: ApprovedMembersList
  },
  {
    path: '/membership/rejectedmembers',
    // name: 'Membership/RejectedMembers',
    element: RejectedMembers
  },

  {
    path: '/membership/viewmembers/:memberid',
    // name: 'Membership/ViewMembers',
    element: ViewMembers
  },

  {
    path: './masters',
    name: <Translation>{(t) => t('masters')}</Translation>,
    exact: true,
  },
  {
    path: '/masters/bodytype/bodytypelist',
    // name: "BodyType/BodyTypeList",
    element: BodyTypeList
  },
  {
    path: '/masters/bodytype/addbodytype',
    // name: "BodyType/BodyTypeList/AddBodyType",
    element: AddBodyType
  },
  {
    path: '/masters/bodytype/editbodytype/:bid',
    // name: "BodyType/BodyTypeList/EditBodyType",
    element: EditBodyType
  },
  {
    path: '/masters/annualincome/annualincomelist',
    // name: "AnnualIncome/AnnualIncomeList",
    element: AnnualIncomeList
  },
  {
    path: '/masters/annualincome/addannualincome',
    // name: "AnnualIncome/AnnualIncomeList/AddAnnualIncome",
    element: AddAnnualIncome
  },
  {
    path: '/masters/annualincome/editannualincome/:aiid',
    // name: "AnnualIncome/AnnualIncomeList/EditAnnualIncome",
    element: EditAnnualIncome
  },
  {
    path: '/masters/category/categorylist',
    // name: "Category/CategoryList",
    element: CategoryList
  },
  {
    path: '/masters/category/addcategory',
    // name: "Category/CategoryList/AddCategory",
    element: AddCategory
  },
  {
    path: '/masters/category/editcategory/:cid',
    // name: "Category/CategoryList/EditCategory",
    element: EditCategory
  },
  {
    path: '/masters/degree/degreelist',
    // name: "Degree/DegreeList",
    element: DegreeList
  },
  {
    path: '/masters/degree/adddegree',
    // name: "Degree/DegreeList/AddDegree",
    element: AddDegree
  },
  {
    path: '/masters/degree/editdegree/:did',
    // name: "Degree/DegreeList/EditDegree",
    element: EditDegree
  },
  {
    path: 'masters/degreegrade/degreegradelist',
    // name: "DegreeGrade/DegreeGradeList",
    element: DegreeGradeList
  },
  {
    path: 'masters/degreegrade/adddegreeGrade',
    // name: "DegreeGrade/DegreeGradeList/AddDegreeGrade",
    element: AddDegreeGrade
  },
  {
    path: 'masters/degreegrade/editdegreeGrade/:did',
    // name: "DegreeGrade/DegreeGradeList/EditDegreeGrade",
    element: EditDegreeGrade
  },
  {
    path: '/masters/designations/designationlist',
    // name: "Designations/DesignationList",
    element: DesignationList
  },
  {
    path: '/masters/designations/adddesignation',
    // name: "Designations/DesignationList/AddDesignation",
    element: AddDesignation
  },
  {
    path: '/masters/designations/editdesignation/:did',
    // name: "Designations/DesignationList/EditDesignation",
    element: EditDesignation
  },
  {
    path: '/masters/empnature/empnaturelist',
    // name: "EmployementNature/EmpNatureList",
    element: EmpNatureList
  },
  {
    path: '/masters/empnature/addempnature',
    // name: "EmployementNature/EmpNatureList/AddEmpNature",
    element: AddEmpNature
  },
  {
    path: '/masters/empnature/editempnature/:did',
    // name: "EmployementNature/EmpNatureList/EditEmpNature",
    element: EditEmpNature
  },
  {
    path: '/masters/gender/genderlist',
    // name: "Gender/GenderList",
    element: GendersList
  },
  {
    path: '/masters/gender/addgender',
    // name: "Gender/GenderList/AddGender",
    element: AddGender
  },
  {
    path: '/masters/gender/editgender/:did',
    // name: "Gender/GenderList/EditGender",
    element: EditGender
  },
  {
    path: '/masters/maritalstatus/maritalstatuslist',
    // name: "MaritalStatus/MaritalStatusList",
    element: MaritalStatusList
  },
  {
    path: '/masters/maritalstatus/addmaritalstatus',
    // name: "MaritalStatus/MaritalStatusList/AddMaritalStatus",
    element: AddMaritalStatus
  },
  {
    path: '/masters/maritalstatus/editmaritalstatus/:did',
    // name: "MaritalStatus/MaritalStatusList/EditMaritalStatus",
    element: EditMaritalStatus
  },
  {
    path: '/masters/nationality/nationalitylist',
    // name: "Nationality/NationalityList",
    element: NationalityList
  },
  {
    path: '/masters/nationality/addnationality',
    // name: "Nationality/NationalityList/AddNationality",
    element: AddNationality
  },
  {
    path: '/masters/nationality/editnationality/:did',
    // name: "Nationality/NationalityList/EditNationality",
    element: EditNationality
  },
  {
    path: '/masters/mothertongue/mothertonguelist',
    // name: "MotherTongue/MotherTongueList",
    element: MotherTongueList
  },
  {
    path: '/masters/mothertongue/addmothertongue',
    // name: "MotherTongue/MotherTongueList/AddMotherTongue",
    element: AddMotherTongue
  },
  {
    path: '/masters/mothertongue/editmothertongue/:did',
    // name: "MotherTongue/MotherTongueList/EditMotherTongue",
    element: EditMotherTongue
  },
  {
    path: '/masters/occupation/occupationslist',
    // name: "Occupation/OccupationsList",
    element: OccupationsList
  },
  {
    path: '/masters/occupation/addoccupation',
    // name: "Occupation/OccupationsList/AddOccupation",
    element: AddOccupation
  },
  {
    path: '/masters/occupation/editoccupation/:did',
    // name: "Occupation/OccupationsList/EditOccupation",
    element: EditOccupation
  },
  {
    path: '/masters/relationship/relationshiplist',
    // name: "Relationship/RelationshipList",
    element: RelationshipList
  },
  {
    path: '/masters/relationship/addrelationship',
    // name: "Relationship/RelationshipList/AddRelationship",
    element: AddRelationship
  },
  {
    path: '/masters/relationship/editrelationship/:did',
    // name: "Relationship/RelationshipList/EditRelationship",
    element: EditRelationship
  },
  {
    path: '/masters/religion/religionslist',
    // name: "Religion/ReligionsList",
    element: ReligionsList
  },
  {
    path: '/masters/religion/addreligion',
    // name: "Religion/ReligionsList/AddReligion",
    element: AddReligion
  },
  {
    path: '/masters/religion/editreligion/:did',
    // name: "Religion/ReligionsList/EditReligion",
    element: EditReligion
  },
  {
    path: '/masters/skincolors/skincolorslist',
    // name: "SkinColors/SkinColorsList",
    element: SkinColorsList
  },
  {
    path: '/masters/skincolors/addskincolor',
    // name: "SkinColors/SkinColorsList/AddSkinColor",
    element: AddSkinColor
  },
  {
    path: '/masters/skincolors/editskincolor/:did',
    // name: "SkinColors/SkinColorsList/EditSkinColor",
    element: EditSkinColor
  },

  {
    path: './jobs',
    name: <Translation>{(t) => t('jobs')}</Translation>,
    exact: true,
  },
  {
    path: '/jobs/pendingjobs',
    // name: 'Jobs/PendingJobs',
    element: PendingJobs
  },
  {
    path: '/jobs/approvedjobs',
    // name: 'Jobs/ApprovedJobs',
    element: ApprovedJobs
  },
  {
    path: '/jobs/rejectedjobs',
    // name: 'Jobs/RejectedJobs',
    element: RejectedJobs
  },
  {
    path: '/jobs/viewjobs/:jobId',
    // name: 'Jobs/ViewJobs',
    element: ViewJobs
  },

  {
    path: './matrimonial',
    name: <Translation>{(t) => t('matrimonial')}</Translation>,
    exact: true,
  },
  {
    path: '/matrimonial/pendingmembermatrimonial',
    // name: 'Matrimonial/PendingMemberMatrimonial',
    element: PendingMemberMatrimonial
  },
  {
    path: '/matrimonial/approvemembermatrimonial',
    // name: 'Matrimonial/ApproveMemberMatrimonial',
    element: ApproveMemberMatrimonial
  },
  {
    path: '/matrimonial/rejectedprofiles',
    // name: 'Matrimonial/RejectedProfiles',
    element: RejectedProfiles
  },
  {
    path: '/matrimonial/viewprofile/:MemberMatrimonial_Id',
    // name: 'Matrimonial/ViewProfile',
    element: ViewProfiles
  },
]

export default routes
